import React, { Component } from 'react';
import './css/App.css';
import Layout from './client/components/layout'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Layout/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js